<template>
  <div class="page">
    <div class="loader-container">
      <div class="dotted-loader"></div>
      <div class="waiting-text">Waiting For Response(s)</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.dotted-loader {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dotted-loader::after,
.dotted-loader::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  border-color: rgba(21, 195, 154, 1) transparent rgba(21, 195, 154, 1) transparent;
}

.dotted-loader::before {
  width: 60px;
  height: 60px;
  animation: turn-right 1.5s linear infinite;
}

.dotted-loader::after {
  width: 40px;
  height: 40px;
  animation: turn-left 1.5s linear infinite;
}

.waiting-text {
  margin-top: 15px;
  font-size: 16px;
  color: #333;
}

@keyframes turn-right {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes turn-left {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
